import React from 'react'
import { View, Text } from 'react-native'
import { useResponsive } from '../hooks'
import {
  invoiceStatus,
  statusBadge,
} from '../../../models/src/dictionaries/invoiceStatus'

type Status = typeof invoiceStatus[keyof typeof invoiceStatus]

interface Props {
  testID?: string
  size?: 'default' | 'small'
  type: Status
}

export default ({ type = 'placed', size = 'default', testID }: Props) => {
  const { sm } = useResponsive()

  return (
    <View
      testID={testID}
      style={{
        paddingVertical: sm || size === 'default' ? 5 : 3,
        borderRadius: 5,
        backgroundColor: statusBadge[type].bgColor,
        paddingHorizontal: sm || size === 'default' ? 8 : 5,
      }}
    >
      <Text
        style={{ color: statusBadge[type].textColor, fontSize: sm ? 14 : 12 }}
      >
        {statusBadge[type]?.label}
      </Text>
    </View>
  )
}
